import { render, staticRenderFns } from "./InsuranceCompanyCards.vue?vue&type=template&id=1a3756b0&"
import script from "./InsuranceCompanyCards.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports